import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { faCircle as faDonut } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { UserStatusEnum } from 'src/app/samwebDescription/samwin/UserStatusEnum';
import { PilotPanelState } from 'src/app/store/dashboard/pilot-panel/pilot-panel.state';
import { UserStatusInfoRemoteDto } from '../../../../generated/signalR/user-status-info-remote-dto';

@Component({
   selector: 'samweb-agent-status',
   templateUrl: './agent-status.component.html',
   styleUrls: ['./agent-status.component.scss'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class AgentStatusComponent implements OnChanges, OnInit {
   @Input()
   public statusInfo: UserStatusInfoRemoteDto;

   @Input()
   public hideIcon = false;

   @Input()
   public statusIcon: IconDefinition = faCircle;

   @Select(PilotPanelState.isPilotPanelExtended)
   public isPilotPanelExtended$: Observable<boolean>;

   public statusName: string;

   public donutIcon: IconDefinition = faDonut;
   public offline = UserStatusEnum.OFFLINE.value;

   constructor(private translateService: TranslateService) {}

   ngOnInit() {}

   ngOnChanges(changes: SimpleChanges): void {
      if (changes?.statusInfo?.previousValue !== changes?.statusInfo?.currentValue) {
         this.updateStatusName();
      }
   }

   updateStatusName() {
      if (!this.statusInfo) {
         this.statusName = '';
         return;
      }

      if (!_.isEmpty(this.statusInfo.customStatusName)) {
         this.statusName = this.statusInfo.customStatusName;
         return;
      }

      switch (this.statusInfo.id) {
         case UserStatusEnum.OFFLINE.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.offline');
            return;
         case UserStatusEnum.AVAILABLE.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.available');
            return;
         case UserStatusEnum.LOGGED_OFF.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.loggedoff');
            return;
         case UserStatusEnum.ACW.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.acw');
            return;
         case UserStatusEnum.DND.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.dnd');
            return;
         case UserStatusEnum.CALL_WAITING.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.callwaiting');
            return;
         case UserStatusEnum.BUSY.value:
            this.statusName = this.translateService.instant('samwin.types.user_status.busy');
            return;
      }

      this.statusName = '';
   }
}
